import { Component, OnInit, OnChanges, Input, SimpleChanges, OnDestroy } from '@angular/core';
import { FormGroup, FormBuilder } from '@angular/forms';
import { HtmlFile } from '@classes/wiki/html-file.model';
import { EditorService } from '@services/wiki/editor.service';
import { FileOrDirService } from '@services/wiki/file-or-dir.service';
import { UtilitiyService } from '@services/wiki/utility.service';
import { UiService } from '@services/ui.service';
import { UploadedFiles } from '@classes/wiki/uploaded-files.model';
import { NameAndPath } from '@classes/wiki/name-and-path.model';
import { RenameFileOrDir } from '@classes/wiki/rename-file-or-dir.model';
import { DirectoryModel } from '@classes/wiki/directory-model.model';
import { FileService } from '@services/wiki/file.service';
import { Subscription } from 'rxjs';
import * as BalloonEditor from '../../../../ckeditor5-build-balloon';

@Component({
  selector: 'app-editor',
  templateUrl: './editor.component.html',
  styleUrls: ['./editor.component.scss']
})
export class EditorComponent implements OnInit, OnChanges, OnDestroy {

  @Input()editable: boolean;
  @Input()filePath: string;
  @Input()language: string;

  private eventSub: Subscription;
  private providerSub: Subscription;

  private provider: string = null;
  private isBizzDev = false;

  Editor = BalloonEditor;

  fileName = '';
  newName: string;
  renameForm: FormGroup;
  htmlFile = new HtmlFile();
  isLoading = false;
  first = true;

  editorConfig = {
    placeholder: 'Type the content here !'
  };

  constructor(
    private editorService: EditorService,
    private fileOrDirService: FileOrDirService,
    private fb: FormBuilder,
    private utilityService: UtilitiyService,
    private fileService: FileService,
    private uiService: UiService) {
  }

  ngOnInit() {
    this.initPage();
  }

  ngOnChanges(changes: SimpleChanges) {
    for (const propName in changes) {
      if (changes.hasOwnProperty(propName) && propName !== 'editable' && propName !== 'language') { // pour ne faire l'appel qu'une fois
        this.loadPage();
      }
    }
  }

  onSubmit(): void { // met en forme pour l'écriture du fichier et envoie
    const regex1 = /<\//gi;
    const regex2 = />/gi;
    const newStr = this.htmlFile.htmlContent.replace(regex1, '\n</');
    const finalStr = newStr.replace(regex2, '>\n');

    const file = new UploadedFiles(finalStr, this.filePath, this.fileName, this.language);
    this.editorService.uploadFile(file).subscribe(() => {
      this.uiService.showSnackbar('wiki.snackBar.updated.summary', true);
    });
  }

  private loadPage(): void {
    this.isLoading = true;
    if (this.filePath) {
      this.provider = this.fileService.providerSub.value;
      this.editorService.getFile(this.filePath, this.language, this.provider).subscribe(data => {
        this.isLoading = false;
        this.htmlFile = data;
        this.fileName = data.htmlName;
        this.fileService.changeEditorSub(new NameAndPath(this.fileName, this.filePath));
      });
    }
  }

  changeName(path: string): void {
    if (this.fileName !== this.newName) {
      const renameObject = new RenameFileOrDir(new DirectoryModel(path), this.newName, this.language);
      this.editorService.changeName(renameObject).subscribe((fm) => {
        this.fileService.changeLanguageTreeSub(path.substring(path.length - 7, path.length - 5));
        this.uiService.showSnackbar('wiki.snackBar.modified.summary', true);
        this.fileName = fm.name;
      });
    }
  }

  uploadFile(event) {
    for (const element of event) {
      if (element.name.endsWith('.html')) {
        const fileReader = new FileReader();
        fileReader.onload = () => {
          const tempo = fileReader.result as string;
          this.htmlFile.htmlContent = decodeURIComponent(escape(tempo));
        };
        fileReader.readAsBinaryString(element);
      }
    }
  }

  stripHtml(html: string) {
    return this.utilityService.stripHtml(html);
  }

  private initPage(): void {
    this.providerSub = (this.fileService.getProviderSub().subscribe(resp => {
      this.provider = resp;
      // this.loadPage();
    }));
    this.eventSub = this.fileOrDirService.getEvent().subscribe((response) => {
      if (!this.editable) {
        this.filePath = response.path;
        this.fileName = response.name;
        this.loadPage();
      }
    });
    this.Editor.isReadOnly = true;
    this.renameForm = this.fb.group({
      renameInput: [this.stripHtml(this.fileName)]
    });
    this.newName = this.fileName;
    this.renameForm.controls.renameInput.valueChanges.subscribe(newTitle => {
      this.newName = newTitle;
    });
  }

  ngOnDestroy(): void {
    if (this.eventSub) {
      this.eventSub.unsubscribe();
    }
    if (this.providerSub) {
      this.providerSub.unsubscribe();
    }
  }
}
